import(/* webpackMode: "eager" */ "/app/assets/images/icon/play-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/customLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/myImage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/videosComponent/popularVideos/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/widgets/trendingPlayer/index.tsx");
